function getFocusableElements(e) {
	return Array.from(
		e.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	)
}
document.querySelectorAll('[id^="Details-"] summary').forEach(e => {
	e.setAttribute('role', 'button'),
		e.setAttribute('aria-expanded', e.parentNode.hasAttribute('open')),
		e.nextElementSibling.getAttribute('id') && e.setAttribute('aria-controls', e.nextElementSibling.id),
		e.addEventListener('click', e => {
			e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'))
		}),
		e.closest('header-drawer') || e.parentElement.addEventListener('keyup', onKeyUpEscape)
})
const trapFocusHandlers = {}

function trapFocus(e, t = e) {
	var i = getFocusableElements(e),
		s = i[0],
		n = i[i.length - 1]
	removeTrapFocus(),
		(trapFocusHandlers.focusin = t => {
			;(t.target !== e && t.target !== n && t.target !== s) || document.addEventListener('keydown', trapFocusHandlers.keydown)
		}),
		(trapFocusHandlers.focusout = function () {
			document.removeEventListener('keydown', trapFocusHandlers.keydown)
		}),
		(trapFocusHandlers.keydown = function (t) {
			'TAB' === t.code.toUpperCase() &&
				(t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()),
				(t.target !== e && t.target !== s) || !t.shiftKey || (t.preventDefault(), n.focus()))
		}),
		document.addEventListener('focusout', trapFocusHandlers.focusout),
		document.addEventListener('focusin', trapFocusHandlers.focusin),
		t.focus()
}
try {
	document.querySelector(':focus-visible')
} catch (e) {
	focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
	const e = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
	let t = null,
		i = null
	window.addEventListener('keydown', t => {
		e.includes(t.code.toUpperCase()) && (i = !1)
	}),
		window.addEventListener('mousedown', e => {
			i = !0
		}),
		window.addEventListener(
			'focus',
			() => {
				t && t.classList.remove('focused'), i || ((t = document.activeElement), t.classList.add('focused'))
			},
			!0
		)
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach(e => {
		e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
	}),
		document.querySelectorAll('.js-vimeo').forEach(e => {
			e.contentWindow.postMessage('{"method":"pause"}', '*')
		}),
		document.querySelectorAll('video').forEach(e => e.pause()),
		document.querySelectorAll('product-model').forEach(e => {
			e.modelViewerUI && e.modelViewerUI.pause()
		})
}

function removeTrapFocus(e = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin),
		document.removeEventListener('focusout', trapFocusHandlers.focusout),
		document.removeEventListener('keydown', trapFocusHandlers.keydown),
		e && e.focus()
}

function onKeyUpEscape(e) {
	if ('ESCAPE' !== e.code.toUpperCase()) return
	const t = e.target.closest('details[open]')
	if (!t) return
	const i = t.querySelector('summary')
	t.removeAttribute('open'), i.setAttribute('aria-expanded', !1), i.focus()
}
class QuantityInput extends HTMLElement {
	constructor() {
		super(),
			(this.input = this.querySelector('input')),
			(this.changeEvent = new Event('change', {
				bubbles: !0
			})),
			this.querySelectorAll('button').forEach(e => e.addEventListener('click', this.onButtonClick.bind(this)))
	}
	onButtonClick(e) {
		e.preventDefault()
		const t = this.input.value
		'plus' === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
	}
}

function debounce(e, t) {
	let i
	return (...s) => {
		clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t))
	}
}

function fetchConfig(e = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${e}`
		}
	}
}
customElements.define('quantity-input', QuantityInput),
	void 0 === window.Shopify && (window.Shopify = {}),
	(Shopify.bind = function (e, t) {
		return function () {
			return e.apply(t, arguments)
		}
	}),
	(Shopify.setSelectorByValue = function (e, t) {
		for (var i = 0, s = e.options.length; i < s; i++) {
			var n = e.options[i]
			if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i), i
		}
	}),
	(Shopify.addListener = function (e, t, i) {
		e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent('on' + t, i)
	}),
	(Shopify.postLink = function (e, t) {
		var i = (t = t || {}).method || 'post',
			s = t.parameters || {},
			n = document.createElement('form')
		for (var o in (n.setAttribute('method', i), n.setAttribute('action', e), s)) {
			var r = document.createElement('input')
			r.setAttribute('type', 'hidden'), r.setAttribute('name', o), r.setAttribute('value', s[o]), n.appendChild(r)
		}
		document.body.appendChild(n), n.submit(), document.body.removeChild(n)
	}),
	(Shopify.CountryProvinceSelector = function (e, t, i) {
		;(this.countryEl = document.getElementById(e)),
			(this.provinceEl = document.getElementById(t)),
			(this.provinceContainer = document.getElementById(i.hideElement || t)),
			Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this)),
			this.initCountry(),
			this.initProvince()
	}),
	(Shopify.CountryProvinceSelector.prototype = {
		initCountry: function () {
			var e = this.countryEl.getAttribute('data-default')
			Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler()
		},
		initProvince: function () {
			var e = this.provinceEl.getAttribute('data-default')
			e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e)
		},
		countryHandler: function (e) {
			var t = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute('data-provinces'),
				i = JSON.parse(t)
			if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = 'none'
			else {
				for (var s = 0; s < i.length; s++) {
					var n
					;((n = document.createElement('option')).value = i[s][0]), (n.innerHTML = i[s][1]), this.provinceEl.appendChild(n)
				}
				this.provinceContainer.style.display = ''
			}
		},
		clearOptions: function (e) {
			for (; e.firstChild; ) e.removeChild(e.firstChild)
		},
		setOptions: function (e, t) {
			var i = 0
			for (t.length; i < t.length; i++) {
				var s = document.createElement('option')
				;(s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s)
			}
		}
	})
class MenuDrawer extends HTMLElement {
	constructor() {
		super(),
			(this.mainDetailsToggle = this.querySelector('details')),
			'iPhone' === navigator.platform && document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`),
			this.addEventListener('keyup', this.onKeyUp.bind(this)),
			this.addEventListener('focusout', this.onFocusOut.bind(this)),
			this.bindEvents()
	}
	bindEvents() {
		this.querySelectorAll('summary').forEach(e => e.addEventListener('click', this.onSummaryClick.bind(this))),
			this.querySelectorAll('button').forEach(e => e.addEventListener('click', this.onCloseButtonClick.bind(this)))
	}
	onKeyUp(e) {
		if ('ESCAPE' !== e.code.toUpperCase()) return
		const t = e.target.closest('details[open]')
		t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(t))
	}
	onSummaryClick(e) {
		const t = e.currentTarget,
			i = t.parentNode,
			s = i.closest('.has-submenu'),
			n = i.hasAttribute('open'),
			o = window.matchMedia('(prefers-reduced-motion: reduce)')

		function r() {
			trapFocus(t.nextElementSibling, i.querySelector('button')), t.nextElementSibling.removeEventListener('transitionend', r)
		}
		i === this.mainDetailsToggle
			? (n && e.preventDefault(), n ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t))
			: setTimeout(() => {
					i.classList.add('menu-opening'),
						t.setAttribute('aria-expanded', !0),
						s && s.classList.add('submenu-open'),
						!o || o.matches ? r() : t.nextElementSibling.addEventListener('transitionend', r)
				}, 100)
	}
	openMenuDrawer(e) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		}),
			e.setAttribute('aria-expanded', !0),
			trapFocus(this.mainDetailsToggle, e),
			document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`, 'close-cursor')
	}
	closeMenuDrawer(e, t = !1) {
		void 0 !== e &&
			(this.mainDetailsToggle.classList.remove('menu-opening'),
			this.mainDetailsToggle.querySelectorAll('details').forEach(e => {
				e.removeAttribute('open'), e.classList.remove('menu-opening')
			}),
			this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(e => {
				e.classList.remove('submenu-open')
			}),
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`, 'close-cursor'),
			removeTrapFocus(t),
			this.closeAnimation(this.mainDetailsToggle))
	}
	onFocusOut(e) {
		setTimeout(() => {
			!this.mainDetailsToggle.hasAttribute('open') ||
				this.mainDetailsToggle.contains(document.activeElement) ||
				this.classList.contains('mobile-facets__wrapper')
		})
	}
	onCloseButtonClick(e) {
		const t = e.currentTarget.closest('details')
		this.closeSubmenu(t)
	}
	closeSubmenu(e) {
		const t = e.closest('.submenu-open')
		t && t.classList.remove('submenu-open'),
			e.classList.remove('menu-opening'),
			e.querySelector('summary').setAttribute('aria-expanded', !1),
			removeTrapFocus(e.querySelector('summary')),
			this.closeAnimation(e)
	}
	closeAnimation(e) {
		let t
		const i = s => {
			void 0 === t && (t = s),
				s - t < 400
					? window.requestAnimationFrame(i)
					: (e.removeAttribute('open'), e.closest('details[open]') && trapFocus(e.closest('details[open]'), e.querySelector('summary')))
		}
		window.requestAnimationFrame(i)
	}
}
customElements.define('menu-drawer', MenuDrawer)
class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}
	openMenuDrawer(e) {
		;(this.header = this.header || document.getElementById('shopify-section-header')),
			(this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0),
			document.documentElement.style.setProperty(
				'--header-bottom-position',
				`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
			),
			this.header.classList.add('menu-open'),
			setTimeout(() => {
				this.mainDetailsToggle.classList.add('menu-opening')
			}),
			e.setAttribute('aria-expanded', !0),
			trapFocus(this.mainDetailsToggle, e),
			document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`),
			this.header.querySelector('.header-wrapper').classList.add('invert')
	}
	closeMenuDrawer(e, t) {
		super.closeMenuDrawer(e, t), this.header.classList.remove('menu-open'), this.header.querySelector('.header-wrapper').classList.remove('invert')
	}
}
customElements.define('header-drawer', HeaderDrawer)
class ModalDialog extends HTMLElement {
	constructor() {
		super(),
			this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, !1)),
			this.addEventListener('keyup', e => {
				'ESCAPE' === e.code.toUpperCase() && this.hide()
			}),
			this.classList.contains('media-modal')
				? this.addEventListener('pointerup', e => {
						'mouse' !== e.pointerType || e.target.closest('deferred-media, product-model') || this.hide()
					})
				: this.addEventListener('click', e => {
						e.target === this && this.hide()
					})
	}
	connectedCallback() {
		this.moved || ((this.moved = !0), document.body.appendChild(this))
	}
	show(e) {
		this.openedBy = e
		const t = this.querySelector('.template-popup')
		document.body.classList.add('overflow-hidden'),
			this.setAttribute('open', ''),
			t && t.loadContent(),
			trapFocus(this, this.querySelector('[role="dialog"]')),
			window.pauseAllMedia()
	}
	hide() {
		document.body.classList.remove('overflow-hidden'),
			document.body.dispatchEvent(new CustomEvent('modalClosed')),
			this.removeAttribute('open'),
			removeTrapFocus(this.openedBy),
			window.pauseAllMedia()
	}
}
customElements.define('modal-dialog', ModalDialog)
class ModalOpener extends HTMLElement {
	constructor() {
		super()
		const e = this.querySelector('button')
		e &&
			e.addEventListener('click', () => {
				const t = document.querySelector(this.getAttribute('data-modal'))
				t && t.show(e)
			})
	}
}
customElements.define('modal-opener', ModalOpener)
class DeferredMedia extends HTMLElement {
	constructor() {
		super()
		const e = this.querySelector('[id^="Deferred-Poster-"]')
		e && e.addEventListener('click', this.loadContent.bind(this))
	}
	loadContent(e = !0) {
		if ((window.pauseAllMedia(), !this.getAttribute('loaded'))) {
			const t = document.createElement('div')
			t.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(!0)), this.setAttribute('loaded', !0)
			const i = this.appendChild(t.querySelector('video, model-viewer, iframe'))
			e && i.focus()
		}
	}
}
customElements.define('deferred-media', DeferredMedia)
class SliderComponent extends HTMLElement {
	constructor() {
		super(),
			(this.slider = this.querySelector('[id^="Slider-"]')),
			(this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
			(this.enableSliderLooping = !1),
			(this.currentPageElement = this.querySelector('.slider-counter--current')),
			(this.pageTotalElement = this.querySelector('.slider-counter--total')),
			(this.prevButton = this.querySelector('button[name="previous"]')),
			(this.nextButton = this.querySelector('button[name="next"]')),
			this.slider &&
				this.nextButton &&
				(this.initPages(),
				new ResizeObserver(e => this.initPages()).observe(this.slider),
				this.slider.addEventListener('scroll', this.update.bind(this)),
				this.prevButton.addEventListener('click', this.onButtonClick.bind(this)),
				this.nextButton.addEventListener('click', this.onButtonClick.bind(this)))
	}
	initPages() {
		;(this.sliderItemsToShow = Array.from(this.sliderItems).filter(e => e.clientWidth > 0)),
			this.sliderItemsToShow.length < 2 ||
				((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
				(this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)),
				(this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
				this.update())
	}
	resetPages() {
		;(this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages()
	}
	update() {
		const e = this.currentPage
		;(this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
			this.currentPageElement &&
				this.pageTotalElement &&
				((this.currentPageElement.textContent = this.currentPage), (this.pageTotalElement.textContent = this.totalPages)),
			this.currentPage != e &&
				this.dispatchEvent(
					new CustomEvent('slideChanged', {
						detail: {
							currentPage: this.currentPage,
							currentElement: this.sliderItemsToShow[this.currentPage - 1]
						}
					})
				),
			this.enableSliderLooping ||
				(this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft
					? this.prevButton.setAttribute('disabled', 'disabled')
					: this.prevButton.removeAttribute('disabled'),
				this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
					? this.nextButton.setAttribute('disabled', 'disabled')
					: this.nextButton.removeAttribute('disabled'))
	}
	isSlideVisible(e, t = 0) {
		const i = this.slider.clientWidth + this.slider.scrollLeft - t
		return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.slider.scrollLeft
	}
	onButtonClick(e) {
		e.preventDefault()
		const t = e.currentTarget.dataset.step || 1
		;(this.slideScrollPosition =
			'next' === e.currentTarget.name ? this.slider.scrollLeft + t * this.sliderItemOffset : this.slider.scrollLeft - t * this.sliderItemOffset),
			this.slider.scrollTo({
				left: this.slideScrollPosition
			})
	}
}
customElements.define('slider-component', SliderComponent)
class SlideshowComponent extends SliderComponent {
	constructor() {
		super(),
			(this.sliderControlWrapper = this.querySelector('.slider-buttons')),
			(this.enableSliderLooping = !0),
			this.sliderControlWrapper &&
				((this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')),
				this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
				(this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'))),
				this.sliderControlLinksArray.forEach(e => e.addEventListener('click', this.linkToSlide.bind(this))),
				this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this)),
				this.setSlideVisibility(),
				'true' === this.slider.getAttribute('data-autoplay') && this.setAutoPlay())
	}
	setAutoPlay() {
		;(this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')),
			(this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
			this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this)),
			this.addEventListener('mouseover', this.focusInHandling.bind(this)),
			this.addEventListener('mouseleave', this.focusOutHandling.bind(this)),
			this.addEventListener('focusin', this.focusInHandling.bind(this)),
			this.addEventListener('focusout', this.focusOutHandling.bind(this)),
			this.play(),
			(this.autoplayButtonIsSetToPlay = !0)
	}
	onButtonClick(e) {
		super.onButtonClick(e)
		const t = 1 === this.currentPage,
			i = this.currentPage === this.sliderItemsToShow.length
		;(t || i) &&
			(t && 'previous' === e.currentTarget.name
				? (this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
				: i && 'next' === e.currentTarget.name && (this.slideScrollPosition = 0),
			this.slider.scrollTo({
				left: this.slideScrollPosition
			}))
	}
	update() {
		super.update(),
			(this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')),
			this.prevButton.removeAttribute('disabled'),
			this.sliderControlButtons.length &&
				(this.sliderControlButtons.forEach(e => {
					e.classList.remove('slider-counter__link--active'), e.removeAttribute('aria-current')
				}),
				this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active'),
				this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', !0))
	}
	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
			this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
			(this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay)
	}
	focusOutHandling(e) {
		const t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target)
		this.autoplayButtonIsSetToPlay && !t && this.play()
	}
	focusInHandling(e) {
		;(e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target)) && this.autoplayButtonIsSetToPlay
			? this.play()
			: this.autoplayButtonIsSetToPlay && this.pause()
	}
	play() {
		this.slider.setAttribute('aria-live', 'off'),
			clearInterval(this.autoplay),
			(this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed))
	}
	pause() {
		this.slider.setAttribute('aria-live', 'polite'), clearInterval(this.autoplay)
	}
	togglePlayButtonState(e) {
		e
			? (this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused'),
				this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow))
			: (this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused'),
				this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow))
	}
	autoRotateSlides() {
		const e = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth
		this.slider.scrollTo({
			left: e
		})
	}
	setSlideVisibility() {
		this.sliderItemsToShow.forEach((e, t) => {
			const i = e.querySelector('a')
			t === this.currentPage - 1
				? (i && i.removeAttribute('tabindex'), e.setAttribute('aria-hidden', 'false'), e.removeAttribute('tabindex'))
				: (i && i.setAttribute('tabindex', '-1'), e.setAttribute('aria-hidden', 'true'), e.setAttribute('tabindex', '-1'))
		})
	}
	linkToSlide(e) {
		e.preventDefault()
		const t =
			this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage)
		this.slider.scrollTo({
			left: t
		})
	}
}
customElements.define('slideshow-component', SlideshowComponent)

class VariantSelects extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('change', this.onVariantChange)
	}

	onVariantChange(event) {
		this.updateOptions()
		this.updateMasterId()
		this.updateSelectedSwatchValue(event)
		this.toggleAddButton(true, '', false)
		this.updatePickupAvailability()
		this.removeErrorMessage()
		this.updateVariantStatuses()

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true)
			this.setUnavailable()
		} else {
			this.updateURL()
			this.updateVariantInput()
			this.renderProductInfo()
			this.updateShareUrl()
		}
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select, fieldset'), element => {
			if (element.tagName === 'SELECT') {
				return element.value
			}
			if (element.tagName === 'FIELDSET') {
				return Array.from(element.querySelectorAll('input')).find(radio => radio.checked)?.value
			}
		})
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find(variant => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option
				})
				.includes(false)
		})
	}

	updateSelectedSwatchValue({ target }) {
		const { name, value, tagName } = target

		if (tagName === 'SELECT' && target.selectedOptions.length) {
			const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue
			const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`)
			if (!selectedDropdownSwatchValue) return
			if (swatchValue) {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue)
				selectedDropdownSwatchValue.classList.remove('swatch--unavailable')
			} else {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset')
				selectedDropdownSwatchValue.classList.add('swatch--unavailable')
			}

			selectedDropdownSwatchValue.style.setProperty('--swatch-focal-point', target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset')
		} else if (tagName === 'INPUT' && target.type === 'radio') {
			const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`)
			const label = target.getAttribute('data-label')
			if (selectedSwatchValue) selectedSwatchValue.innerHTML = label
		}
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return
		window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
	}

	updateShareUrl() {
		const shareButton = document.getElementById(`Share-${this.dataset.section}`)
		if (!shareButton || !shareButton.updateUrl) return
		shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
		productForms.forEach(productForm => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', { bubbles: true }))
		})
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1)
		const inputWrappers = [...this.querySelectorAll('.product-form__input')]
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected)
				.map(variantOption => variantOption[`option${index + 1}`])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
		})
	}

	setInputAvailability(elementList, availableValuesList) {
		elementList.forEach(element => {
			const value = element.getAttribute('value')
			const availableElement = availableValuesList.includes(value)

			if (element.tagName === 'INPUT') {
				element.classList.toggle('disabled', !availableElement)
			} else if (element.tagName === 'OPTION') {
				element.innerText = availableElement ? value : window.variantStrings.unavailable_with_option.replace('[value]', value)
			}
		})
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability')
		if (!pickUpAvailability) return

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id)
		} else {
			pickUpAvailability.removeAttribute('available')
			pickUpAvailability.innerHTML = ''
		}
	}

	removeErrorMessage() {
		const section = this.closest('section')
		if (!section) return

		const productForm = section.querySelector('product-form')
		if (productForm) productForm.handleErrorMessage()
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id
		const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section

		fetch(
			`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
				this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
			}`
		)
			.then(response => response.text())
			.then(responseText => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return

				const html = new DOMParser().parseFromString(responseText, 'text/html')

				const priceSource = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
				const priceDestination = document.getElementById(`price-${this.dataset.section}`)

				const storiesSource = html.getElementById(`Stories-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
				const storiesDestination = document.getElementById(`Stories-${this.dataset.section}`)

				const thumbnailStoriesSource = html.getElementById(
					`ThumbnailStories-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				)
				const thumbnailStoriesDestination = document.getElementById(`ThumbnailStories-${this.dataset.section}`)

				const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
				const skuDestination = document.getElementById(`Sku-${this.dataset.section}`)
				const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
				const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`)

				const stickySource = html.getElementById(`Sticky-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
				const stickyDestination = document.getElementById(`Sticky-${this.dataset.section}`)

				const volumePricingSource = html.getElementById(
					`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				)
				const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
				const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)

				if (mediaGallerySource && mediaGalleryDestination) mediaGallerySource.innerHTML = mediaGalleryDestination.innerHTML

				const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`)
				const pricePerItemSource = html.getElementById(
					`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				)

				const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`)
				const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`)
				const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`)

				if (volumeNote) volumeNote.classList.remove('hidden')
				if (volumePricingDestination) volumePricingDestination.classList.remove('hidden')
				if (qtyRules) qtyRules.classList.remove('hidden')

				if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML

				if (storiesSource && storiesDestination) storiesDestination.innerHTML = storiesSource.innerHTML
				if (thumbnailStoriesSource && thumbnailStoriesDestination) thumbnailStoriesDestination.innerHTML = thumbnailStoriesSource.innerHTML

				if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML
					skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'))
				}

				if (stickySource && stickyDestination) stickyDestination.innerHTML = stickySource.innerHTML
				stickyDestination.init()

				if (volumePricingSource && volumePricingDestination) {
					volumePricingDestination.innerHTML = volumePricingSource.innerHTML
				}

				if (pricePerItemSource && pricePerItemDestination) {
					pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML
					pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'))
				}

				const price = document.getElementById(`price-${this.dataset.section}`)

				if (price) price.classList.remove('hidden')

				if (inventoryDestination && inventorySource) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '')

				const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`)
				this.toggleAddButton(
					addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
					window.variantStrings.soldOut,
					false,
					addButtonUpdated.innerHTML
				)

				const preorderDateDestination = document.getElementById(`preorder_date`)
				const preorderDateSource = html.getElementById(`preorder_date`)
				if (preorderDateSource && preorderDateDestination) {
					preorderDateDestination.innerHTML = preorderDateSource.innerHTML
				}

				if (preorderDateSource && !preorderDateDestination) {
					// add inside product-form form
					const productForm = document.getElementById(`product-form-${this.dataset.section}`)
					if (productForm) {
						productForm.appendChild(preorderDateSource)
					}
				}

				if (!preorderDateSource && preorderDateDestination) {
					// remove preorder date
					const productForm = document.getElementById(`product-form-${this.dataset.section}`)
					if (productForm) {
						productForm.removeChild(preorderDateDestination)
					}
				}

				publish(PUB_SUB_EVENTS.variantChange, {
					data: {
						sectionId,
						html,
						variant: this.currentVariant
					}
				})
			})
	}

	toggleAddButton(disable = true, text, modifyClass = true, content) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`)
		if (!productForm) return
		const addButton = productForm.querySelector('[name="add"]')
		const addButtonText = productForm.querySelector('[name="add"] > span')
		if (!addButton) return

		if (disable) {
			addButton.setAttribute('disabled', 'disabled')
			if (text) addButtonText.textContent = text
		} else {
			addButton.removeAttribute('disabled')
			if (content) {
				addButtonText.innerHTML = content
			}
			if (!content) {
				addButtonText.textContent = window.variantStrings.addToCart
			}
		}

		if (!modifyClass) return
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`)
		const addButton = button.querySelector('[name="add"]')
		const addButtonText = button.querySelector('[name="add"] > span')
		const price = document.getElementById(`price-${this.dataset.section}`)
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
		const sku = document.getElementById(`Sku-${this.dataset.section}`)
		const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`)
		const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`)
		const volumeTable = document.getElementById(`Volume-${this.dataset.section}`)
		const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`)

		if (!addButton) return
		addButtonText.textContent = window.variantStrings.unavailable
		if (price) price.classList.add('hidden')
		if (inventory) inventory.classList.add('hidden')
		if (sku) sku.classList.add('hidden')
		if (pricePerItem) pricePerItem.classList.add('hidden')
		if (volumeNote) volumeNote.classList.add('hidden')
		if (volumeTable) volumeTable.classList.add('hidden')
		if (qtyRules) qtyRules.classList.add('hidden')
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
		return this.variantData
	}
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}
	updateOptions() {
		const e = Array.from(this.querySelectorAll('fieldset'))
		this.options = e.map(e => Array.from(e.querySelectorAll('input')).find(e => e.checked).value)
	}
}
customElements.define('variant-radios', VariantRadios),
	window.location.search.indexOf('customer_posted') > -1 && window.scrollTo(0, document.body.scrollHeight),
	'#opencart' == window.location.hash && document.querySelector('cart-drawer').classList.add('animate', 'active'),
	document.addEventListener('click', function (e) {
		'cart-all' == e.target.id &&
			setTimeout(function () {
				;(window.location.href = window.location.href + '#opencart'), location.reload()
			}, 1e3)
	})

class AnnouncementBar extends HTMLElement {
	constructor() {
		super()
		this.textElements = this.querySelectorAll('.announcement-bar-item')
		this.currentIndex = 0
		this.toggleActiveElements()
		setInterval(this.toggleActiveElements.bind(this), 10000)
	}

	toggleActiveElements() {
		this.textElements.forEach(element => {
			element.classList.remove('active')

			this._container_w = this.offsetWidth
			this._content_w = element.querySelector('.announcement-bar__message').offsetWidth
			this._container_w <= this._content_w
				? this.classList.add('animated')
				: (this.classList.remove('animated'), (element.querySelector('.announcement-bar__message.duplicated').style.display = 'none'))
		})

		this.textElements[this.currentIndex].classList.add('active')

		this.currentIndex = (this.currentIndex + 1) % this.textElements.length
	}
}
customElements.define('announcement-bar', AnnouncementBar)

class ProgressBar extends HTMLElement {
	constructor() {
		super()
		this.productsData = []
		this.cart = document.querySelector('cart-drawer')
		this.amount = parseFloat(this.getAttribute('amount'))
		this.totalCart = parseFloat(this.getAttribute('total-cart'))
		if (this.querySelector('[data-free-products]')) {
			document.querySelectorAll('.data-free-product').forEach(el => {
				this.productsData.push({
					variantId: el.dataset.variantId,
					freeProductAmount: parseInt(el.dataset.freeProductAmount),
					quantity: parseInt(el.dataset.quantity),
					isInCart: parseInt(el.dataset.isInCart || 0),
					blockId: el.dataset.blockId,
					quantityInCart: parseInt(el.dataset.isInCart || 0)
				})
			})
		}

		// wait 0.5s to make sure cart is updated
		setTimeout(() => {
			this.addOrRemoveFreeProducts()
		}, 500)
	}

	async addOrRemoveFreeProducts() {
		// get each amount group
		const amountGroups = this.productsData.map(product => product.freeProductAmount)
		const amountGroupsUnique = [...new Set(amountGroups)]

		for (const product of this.productsData) {
			if (product.isInCart > 1) {
				this.updateProductFromCart(product.variantId, 1)
			}
		}

		for (const amount of amountGroupsUnique) {
			// delete all products in cart with amount
			const blockId = this.productsData?.filter(product => product.freeProductAmount == amount)[0]?.blockId
			const productSelected = localStorage.getItem(blockId)
			if (amount > this.totalCart) {
				if (productSelected == 'delete') {
					localStorage.removeItem(blockId)
				}
				this.productsData.forEach(async product => {
					if (product.freeProductAmount === amount && product.isInCart) {
						await this.updateProductFromCart(product.variantId, 0)
					}
				})
				continue
			}
			const productsInGroup = this.productsData.filter(product => product.freeProductAmount === amount)
			const productWithMostQuantity = productsInGroup.reduce((a, b) => (a.quantity > b.quantity ? a : b))

			if (productSelected) {
				// delete all products in cart with amount
				if (productSelected == 'delete') {
					productsInGroup.forEach(product => {
						if (product.isInCart) {
							this.updateProductFromCart(product.variantId, 0)
						}
					})
					continue
				}

				console.log(productSelected, productsInGroup)

				// delete all products in cart with amount
				productsInGroup.forEach(product => {
					if (product.variantId !== productSelected && product.isInCart > 0) {
						this.updateProductFromCart(product.variantId, 0)
					}
					if (product.isInCart > 1) {
						this.updateProductFromCart(product.variantId, 1)
					}
					if (product.variantId == productSelected && product.isInCart == 0) {
						this.addProductToCart(product.variantId)
					}
				})
			}
			//if none is selected, select the one with most quantity
			if (!productSelected) {
				if (productWithMostQuantity && !productWithMostQuantity.isInCart) {
					localStorage.setItem(this.getAttribute('data-block-id'), productWithMostQuantity.variantId)
					this.addProductToCart(productWithMostQuantity.variantId)
				}
			}
		}
	}

	async addProductToCart(variantId) {
		const body = JSON.stringify({
			items: [
				{
					id: variantId,
					quantity: 1
				}
			],
			sections: this.cart.getSectionsToRender().map(section => section.id),
			sections_url: window.location.pathname
		})

		await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
			.then(response => response.json())
			.then(data => {
				if (this.cart) this.cart.renderContents(data)
			})
			.catch(error => console.error('Error adding product to cart:', error))
	}
	async updateProductFromCart(variantId, quantity = 0) {
		const body = JSON.stringify({
			id: variantId,
			quantity: quantity,
			sections: this.cart.getSectionsToRender().map(section => section.id),
			sections_url: window.location.pathname
		})

		await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then(response => response.json())
			.then(data => {
				if (this.cart) this.cart.renderContents(data)
			})
			.catch(error => console.error('Error removing product from cart:', error))
	}
}
customElements.define('progress-bar', ProgressBar)

class SelectAProduct extends HTMLElement {
	constructor() {
		super()
		this.init()
	}

	init() {
		this.close = this.querySelector('.drawer__close')
		this.progressBar = document.querySelector('progress-bar')
		this.buttonChange = document.querySelector(`button[id="change"][data-block-id="${this.getAttribute('data-block-id')}"]`)
		this.buttonChange?.addEventListener('click', () => {
			this.classList.toggle('active')
		})

		this.buttonDelete = document.querySelector(`button[id="delete"][data-block-id="${this.getAttribute('data-block-id')}"]`)

		this.dontWant = this.querySelector('.dont-want')

		this.buttonDelete?.addEventListener('click', () => {
			localStorage.setItem(this.getAttribute('data-block-id'), 'delete')
			this.progressBar.addOrRemoveFreeProducts()
		})

		this.close?.addEventListener('click', () => {
			this.classList.remove('active')
		})

		this.dontWant?.addEventListener('click', () => {
			localStorage.setItem(this.getAttribute('data-block-id'), 'delete')
			this.progressBar.addOrRemoveFreeProducts()
			this.classList.remove('active')
		})

		this.productButtonsAdd = this.querySelectorAll('.add-to-cart')
		this.productButtonsAdd.forEach(button => {
			button.addEventListener('click', async e => {
				e.preventDefault()
				const variantId = button.getAttribute('data-variant-id')
				localStorage.setItem(this.getAttribute('data-block-id'), variantId)
				await this.progressBar.addOrRemoveFreeProducts()
			})
		})
	}
}
customElements.define('select-a-product', SelectAProduct)

class giftWrapping extends HTMLElement {
	constructor() {
		super()
		this.cart = document.querySelector('cart-drawer')

		this.variantId = this.getAttribute('data-variant-id')
		this.shouldNotInCart = this.getAttribute('data-should-not-in-cart')
		this.init()
	}
	async init() {
		this.input = this.querySelector('input')

		setTimeout(async () => {
			if (this.shouldNotInCart == 'true') {
				await this.updateProductFromCart(this.variantId, 0)
			}
		}, 300)
		this.input.addEventListener('change', async e => {
			const checked = e.target.checked

			if (checked) {
				await this.addProductToCart(this.variantId)
			}
			if (!checked) {
				await this.updateProductFromCart(this.variantId, 0)
			}
		})
	}

	async addProductToCart(variantId) {
		const body = JSON.stringify({
			items: [
				{
					id: variantId,
					quantity: 1
				}
			],
			sections: this.cart.getSectionsToRender().map(section => section.id),
			sections_url: window.location.pathname
		})

		await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
			.then(response => response.json())
			.then(data => {
				if (this.cart) this.cart.renderContents(data)
			})
			.catch(error => console.error('Error adding product to cart:', error))
	}
	async updateProductFromCart(variantId, quantity = 0) {
		const body = JSON.stringify({
			id: variantId,
			quantity: quantity,
			sections: this.cart.getSectionsToRender().map(section => section.id),
			sections_url: window.location.pathname
		})

		await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then(response => response.json())
			.then(data => {
				if (this.cart) this.cart.renderContents(data)
			})
			.catch(error => console.error('Error removing product from cart:', error))
	}
}

customElements.define('gift-wrapping', giftWrapping)

class Reinsurance extends HTMLElement {
	constructor() {
		super()
		new Swiper(`.reinsurance-slider--${this.getAttribute('data-id')}`, {
			pagination: { el: '.swiper-pagination', loop: !0 },
			autoplay: { delay: 4e3, disableOnInteraction: !1 }
		})
	}
}
customElements.define('reinsurance-slider', Reinsurance)

class RseSlider extends HTMLElement {
	constructor() {
		super()
		new Swiper(`.rse-slider--${this.getAttribute('data-id')}`, {
			slidesPerView: 1.3,
			spaceBetween: 10,
			centeredSlides: !0,
			initialSlide: 1,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			breakpoints: {
				768: {
					slidesPerView: 2.5,
					spaceBetween: 20
				},
				1100: {
					slidesPerView: 3,
					spaceBetween: 20,
					pagination: false
				}
			}
		})
	}
}

customElements.define('rse-slider', RseSlider)

class StickyButton extends HTMLElement {
	constructor() {
		super()
		this.init()
	}
	init() {
		this.addToCart = this.querySelector('.product-form__submit')
		this.originalAddToCart = document.querySelector("button[name='add']")
		if (this.addToCart) {
			this.addToCart.addEventListener('click', () => {
				this.originalAddToCart?.click()
			})
		}
	}
	connectedCallback() {
		const targetToObserve = document.querySelector('.product-form__buttons')
		const addToCart = this

		const callback = (entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					addToCart.classList.remove('active')
				}
				if (!entry.isIntersecting) {
					addToCart.classList.add('active')
				}
			})
		}

		const observer = new IntersectionObserver(callback, {
			root: null,
			rootMargin: '0px',
			threshold: 1.0
		})

		if (targetToObserve) {
			console.log('targetToObserve')
			observer.observe(targetToObserve)
		}
	}
}

customElements.define('sticky-button', StickyButton)

class ScrollInTop extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('click', () => {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		})
	}
}

customElements.define('scroll-in-top', ScrollInTop)

class Privilege extends HTMLElement {
	constructor() {
		super()
		this.triggerId = this.getAttribute('data-trigger-id')
		this.hidePrivilegeBanner()
		this.initKlaviyoTrigger()
		this.handleKlaviyoSubmit()

		// await 1s to make sure the form is loaded
		setTimeout(() => {
			this.hidePrivilegeBanner()
		}, 1000)
	}
	initKlaviyoTrigger() {
		this.querySelector('.klaviyo_form_trigger').addEventListener('click', () => {
			window._klOnsite = window._klOnsite || []
			console.log('triggerId', this.triggerId)
			console.log(window._klOnsite)
			window._klOnsite.openForm(`${this.triggerId}`)
		})
	}
	handleKlaviyoSubmit() {
		window.addEventListener('klaviyoForms', e => {
			console.log(e)
			console.log('type : ', e.detail.type)
			console.log(e.detail.formId, this.triggerId)
			if (e.detail.type == 'submit') {
				if (e.detail.formId == this.triggerId) {
					console.log('form submitted')
					localStorage.setItem('privilege_form_submitted', 'true')
					this.hidePrivilegeBanner()
				}
			}
		})
	}
	hidePrivilegeBanner() {
		if (localStorage.getItem('privilege_form_submitted')) {
			this.remove()
		}
	}
}
customElements.define('privilege-component', Privilege)

document.addEventListener('DOMContentLoaded', () => {
	// if url contains ?privilege=true, add to local storage
	if (window.location.search.includes('?privilege=true')) {
		localStorage.setItem('privilege_form_submitted', 'true')
	}
})
